import { URLS } from "@payping/utilities-shared/consts";
import { UserManager, UserManagerSettings } from "oidc-client";

export interface UserManagerType {
  // eslint-disable-next-line camelcase
  client_id: string;
  // eslint-disable-next-line camelcase
  redirect_uri: string;
  // eslint-disable-next-line camelcase
  response_type: string;
  scope: string;
  authority: string;
}

export const userManagerConfig: UserManagerSettings = {
  client_id: "PayPingWebApp",
  redirect_uri: `${window.location.protocol}//${window.location.hostname}${
    window.location.port ? `:${window.location.port}` : ""
  }/oauth_callback`,
  response_type: "token id_token",
  scope: [
    "offline_access",
    "openid",
    "profile",
    "client:read",
    "client:write",
    "coupon:read",
    "coupon:write",
    "customer:read",
    "customer:write",
    "digitalAccount:read",
    "digitalAccount:write",
    "integration:read",
    "integration:write",
    "invoice:read",
    "invoice:write",
    "settlement:read",
    "settlement:write",
    "pay:read",
    "pay:write",
    "product:read",
    "product:write",
    "signalr:read",
    "timeline:read",
    "upload:write",
    "user:read",
    "user:write",
    "account:read",
    "account:write",
    "bnpl:merchantread",
    "bnpl:merchantwrite",
    "refund:creation",
    "refund:recharge",
    "refund:decharge",
    "shaparak:read",
    "shaparak:write",
  ].join(" "),
};

export const userManager = new UserManager({ authority: URLS.AUTH_URL, ...userManagerConfig });
